import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from '#utils/local-storage/local-storage.service';
import { environment } from 'environments/environment';

const VERSIONS_KEY = 'versions';

@Injectable({ providedIn: 'root' })
export class AppVersionService {
    private _storage = inject(LocalStorageService);

    public async update() {
        this.setlocalVersion(await this.remoteVersion());
    }

    public async outdated() {
        if (!this.#parseVersions().length) return true;

        return (await this.remoteVersion()) !== this.localVersion;
    }

    public async remoteVersion() {
        // TODO: Wait for API
        return this.localVersion;
    }

    public check(v: string) {
        return this.#parseVersions().includes(v);
    }

    public get localVersion(): string {
        return this.#parseVersions().slice().pop() ?? environment.version;
    }

    public setlocalVersion(v: string) {
        this.#setVersion(v);
    }

    #parseVersions(): string[] {
        const versions = this._storage.getItem(VERSIONS_KEY);
        if (!versions) this._storage.setItem(VERSIONS_KEY, '[]');

        return JSON.parse(versions ?? '[]');
    }

    #setVersion(v: string) {
        const versions = this.#parseVersions();
        versions.push(v);
        this._storage.setItem(VERSIONS_KEY, JSON.stringify(versions));
    }
}
